document.addEventListener("DOMContentLoaded", function () {
  console.log("Il codice JavaScript è attivo");

  const menuItems = document.querySelectorAll('[data-toggle="submenu"]');
  if (menuItems.length === 0) {
    console.warn("Nessun elemento di menu trovato con il selettore '[data-toggle=\"submenu\"]'");
  } else {
    menuItems.forEach((menuItem) => {
      console.log("Menu trovato:", menuItem.textContent);

      menuItem.addEventListener("click", (event) => {
        console.log("Cliccato:", menuItem.href);
        window.location.href = menuItem.href; // Passa il click al link
      });
    });
  }

  const submenuItems = document.querySelectorAll('[data-toggle="submenu"]');
  if (submenuItems.length === 0) {
    console.log("Nessun elemento di menu trovato con il selettore '[data-toggle=\"submenu\"]'");
  } else {
    console.log(`${submenuItems.length} elementi trovati.`);
  }
});

